"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTheme = exports.ThemeProvider = void 0;
var ThemeProvider_1 = __importDefault(require("./ThemeProvider"));
exports.ThemeProvider = ThemeProvider_1.default;
var buildTheme_1 = __importDefault(require("./buildTheme"));
exports.buildTheme = buildTheme_1.default;
exports.default = ThemeProvider_1.default;
//# sourceMappingURL=index.js.map